import { render, staticRenderFns } from "./clueDataDetail.vue?vue&type=template&id=4cfda522"
import script from "./clueDataDetail.vue?vue&type=script&lang=js"
export * from "./clueDataDetail.vue?vue&type=script&lang=js"
import style0 from "./clueDataDetail.vue?vue&type=style&index=0&id=4cfda522&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports